import { getDB } from '../db';
export class IndexedDbProjectRepository {
    async listAll() {
        const db = await getDB();
        const all = await db.getAllFromIndex('projects', 'by-updatedAt');
        // índice ordena asc — invertemos para mais recentes primeiro
        return all.reverse();
    }
    async get(id) {
        const db = await getDB();
        return db.get('projects', id);
    }
    async save(project) {
        const db = await getDB();
        await db.put('projects', project);
    }
    async delete(id) {
        const db = await getDB();
        await db.delete('projects', id);
    }
    async clear() {
        const db = await getDB();
        await db.clear('projects');
    }
}
/** Singleton padrão usado pelo app */
export const projectRepository = new IndexedDbProjectRepository();
